export default __webpack_public_path__ + "static/image--delivery-only-b4c21dc1556ccf3fd243eff929ab1184.jpg";